import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { TopicFeedback } from '../topic-feedback-view.part';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, areaService: DeliveryAreaService): GridSetup<TopicFeedback> {

	const staffPermissions = areaService.staffPermissions();

	return {
		rowName: { singular: 'Topic Feedback', plural: 'Topic Feedbacks' },
		getRowKey: row => '' + row.accSessionTopicSurveyResponseId,
		stateKey: 'delivery-topic-feedback-grid',
		actions: [],
		buttons: [],
		columns: getColumns(util),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${areaService.selectedTrimesterName()}-Topic-Feedbacks`
		}
	}
}
